export default function log(message: string) {
  console.log(`[LOG]: ${message}`);
}
